export default __webpack_public_path__ + "static/media/listAlt.75f26c3d.svg";